import { SVGProps } from "react";

export default function ChromeOutlineIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, fill = "none", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6 11.5C8.76 11.5 11 9.26 11 6.5C11 3.74 8.76 1.5 6 1.5C3.24 1.5 1 3.74 1 6.5C1 9.26 3.24 11.5 6 11.5Z"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8.5C7.105 8.5 8 7.605 8 6.5C8 5.395 7.105 4.5 6 4.5C4.895 4.5 4 5.395 4 6.5C4 7.605 4.895 8.5 6 8.5Z"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.585 4.4975C9.075 4.1675 7.51 4.1675 6 4.4975"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.97656 3.53125L1.98656 3.56125C2.49156 5.00625 3.26656 6.34625 4.27156 7.50125"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.4375 11.47C6.4675 10.335 7.2425 8.995 7.7125 7.54L7.7275 7.5"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
